"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UserManagerExternal_1 = __importDefault(require("./UserManagerExternal"));
var defaultSettings = {
    response_type: 'id_token token',
    scope: 'openid id',
    monitorSession: true,
    filterProtocolClaims: true,
    loadUserInfo: false,
    automaticSilentRenew: true,
    revokeAccessTokenOnSignout: true,
};
function getPopWindowLocations() {
    var width = 1024;
    var height = 768;
    var top = 100;
    var left = (window.screen.availWidth - width) / 2;
    return "height=" + height + ", width=" + width + ", top=" + top + ", left=" + left + ",\n    toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no";
}
// In UserManagerClient class, add a promise to wrap the oidc-client api which is a async function, in order to avoid oidc-client api change.
var UserManagerClient = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    function UserManagerClient(settings) {
        this.$$user = null;
        this.$$settings = __assign(__assign({}, defaultSettings), settings);
        this.client = new UserManagerExternal_1.default(this.$$settings);
        this.setUser = this.setUser.bind(this);
        this.client.events.addUserLoaded(this.setUser);
        this.client.events.addUserUnloaded(this.setUser);
    }
    Object.defineProperty(UserManagerClient.prototype, "settings", {
        get: function () {
            if (this.client) {
                return this.client.settings;
            }
            return this.$$settings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserManagerClient.prototype, "user", {
        get: function () {
            return this.$$user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserManagerClient.prototype, "events", {
        get: function () {
            return this.client.events;
        },
        enumerable: false,
        configurable: true
    });
    UserManagerClient.prototype.setUser = function (user) {
        if (user === void 0) { user = null; }
        this.$$user = user;
    };
    UserManagerClient.prototype.signin = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, state = _b.state, _c = _b.redirectUri, redirectUri = _c === void 0 ? null : _c, _d = _b.extraQueryParams, extraQueryParams = _d === void 0 ? {} : _d;
        var urlState = {
            hash: window.location.hash,
            search: window.location.search,
            originalUrl: window.location.href,
        };
        return new Promise(function (resolve, reject) {
            _this.client
                .signinRedirect({ extraQueryParams: extraQueryParams, state: __assign(__assign({}, state), urlState), redirect_uri: redirectUri })
                .then(function () { return resolve(); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.signinCallback = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.client
                .signinRedirectCallback(url)
                .then(function (user) { return resolve(user); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.signout = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, state = _b.state, extraQueryParams = _b.extraQueryParams;
        return new Promise(function (resolve, reject) {
            var newState = state;
            if (extraQueryParams) {
                newState = __assign(__assign({}, state), { extraQueryParams: extraQueryParams });
            }
            _this.client
                .signoutRedirect({ state: newState })
                .then(function () { return resolve(); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.signoutCallback = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.client
                .signoutRedirectCallback(url)
                .then(function (resp) { return resolve(resp); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.popupSignin = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, state = _b.state, popupWindowFeatures = _b.popupWindowFeatures, _c = _b.extraQueryParams, extraQueryParams = _c === void 0 ? {} : _c;
        return new Promise(function (resolve, reject) {
            _this.client
                .signinPopup({
                state: state,
                popupWindowFeatures: popupWindowFeatures || getPopWindowLocations(),
                extraQueryParams: extraQueryParams,
            })
                .then(function (user) { return resolve(user); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.popupSigninCallback = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.client
                .signinPopupCallback(url)
                .then(function (user) { return resolve(user); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.popupSignout = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, state = _b.state, extraQueryParams = _b.extraQueryParams;
        return new Promise(function (resolve, reject) {
            var newState = state;
            if (extraQueryParams) {
                newState = __assign(__assign({}, state), { extraQueryParams: extraQueryParams });
            }
            _this.client
                .signoutPopup({ state: newState })
                .then(function (resp) { return resolve(resp); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.popupSignoutCallback = function (url, keepOpen) {
        var _this = this;
        if (keepOpen === void 0) { keepOpen = false; }
        return new Promise(function (resolve, reject) {
            _this.client
                .signoutPopupCallback(url, keepOpen)
                .then(function () { return resolve(); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.iframeSignin = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, state = _b.state, silentRequestTimeout = _b.silentRequestTimeout, _c = _b.extraQueryParams, extraQueryParams = _c === void 0 ? {} : _c;
        return new Promise(function (resolve, reject) {
            _this.client
                .signinSilent({ extraQueryParams: extraQueryParams, state: state, silentRequestTimeout: silentRequestTimeout })
                .then(function (user) { return resolve(user); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.iframeSigninCallback = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.client
                .signinSilentCallback(url)
                .then(function () { return resolve(); })
                .catch(function (err) { return reject(err); });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    UserManagerClient.prototype.iframeSignout = function (_a) {
        var _this = this;
        var state = _a.state, extraQueryParams = _a.extraQueryParams;
        return new Promise(function (resolve, reject) {
            var newState = state;
            if (extraQueryParams) {
                newState = __assign(__assign({}, state), { extraQueryParams: extraQueryParams });
            }
            _this.client
                .signoutIframe({ state: newState })
                .then(function () { return resolve(); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.iframeSignoutCallback = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.client
                .signoutIframeCallback(url)
                .then(function () { return resolve(); })
                .catch(function (err) { return reject(err); });
        });
    };
    UserManagerClient.prototype.clearState = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.client
                .clearStaleState()
                .then(function () { return resolve(); })
                .catch(function (err) { return reject(err); });
        });
    };
    return UserManagerClient;
}());
exports.default = UserManagerClient;
//# sourceMappingURL=UserManagerClient.js.map